/**
 * Chaîne d'un règlement : technique (RT) → comptable (RC) → annulation (AN).
 *
 * Le règlement comptable est une COPIE du règlement technique, du même montant,
 * rattachée à lui par `parentCodeId` ; une annulation en est une autre. Additionner
 * toutes les lignes comptait donc le même argent deux fois - un règlement de
 * 396 900 FCFA s'affichait « 793 800 » dès qu'il passait en comptabilité.
 *
 * Règle : une seule ligne compte par chaîne, la dernière (celle qui n'a pas d'enfant),
 * et une annulation ne compte pas.
 */

const cle = (v) => (v == null ? '' : String(v).trim());

/** Les lignes qui ne sont le parent d'aucune autre : une par règlement réel. */
export function lignesFinales(paiements = []) {
  const parents = new Set(paiements.map((p) => cle(p.parentCodeId)).filter(Boolean));
  return paiements.filter((p) => !parents.has(cle(p.paiementTrackingId)));
}

/** Nombre de règlements réels (lignes techniques et comptables d'un même règlement = 1). */
export function nombreReglements(paiements = []) {
  return lignesFinales(paiements).length;
}

/** Montant réellement engagé : une fois par règlement, annulations exclues. */
export function montantEffectif(paiements = []) {
  return lignesFinales(paiements)
    .filter((p) => p.statut !== 'ANNULE' && p.typeOperation !== 'ANNULATION_REGLEMENT')
    .reduce((somme, p) => somme + (Number(p.montant) || 0), 0);
}
